import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.nihanshfoundation.in';

function SEO({ title, description, keywords, path = '/' }) {
  const fullUrl = path === '/' ? SITE_URL : `${SITE_URL}${path}`;
  const defaultKeywords = 'nasha mukti kendra in patna,nasha mukti, nasha mukiti in patna, nasha mukti in patna, best nasha mukti in bihar, best nasha mukti in patna, best nasha mukti, nasha mukti kendra patna, नशा मुक्ति पटना';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </Helmet>
  );            
}

export default SEO;
